'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  box-sizing: border-box;\n  *{color: white;}\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: ', ';\n  min-width: 300px;\n  padding: 0px 20px;\n  user-select: none;\n  z-index: 1000;\n  background-color:rgb(17, 17, 17);\n  ', '\n'], ['\n  position: fixed;\n  top: 0;\n  box-sizing: border-box;\n  *{color: white;}\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: ', ';\n  min-width: 300px;\n  padding: 0px 20px;\n  user-select: none;\n  z-index: 1000;\n  background-color:rgb(17, 17, 17);\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    box-shadow: 0px 3px 15px -5px black;\n  '], ['\n    box-shadow: 0px 3px 15px -5px black;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  *{\n    text-decoration:none;\n    font-size: 1.8rem;\n    font-family: Alegreya Sans SC;\n    font-weight: 300;\n    letter-spacing: 1px;\n  }\n'], ['\n  *{\n    text-decoration:none;\n    font-size: 1.8rem;\n    font-family: Alegreya Sans SC;\n    font-weight: 300;\n    letter-spacing: 1px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height:100%;\n  position: relative;\n  ', ';\n'], ['\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height:100%;\n  position: relative;\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    flex-direction: row-reverse;\n  '], ['\n    flex-direction: row-reverse;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  height:100%;\n'], ['\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  height:100%;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  position: absolute;\n  left:50%;\n  transform:translate(-50%);\n  display: flex;\n  align-items: center;\n  height: 100%;\n  max-height: ', ';\n'], ['\n  position: absolute;\n  left:50%;\n  transform:translate(-50%);\n  display: flex;\n  align-items: center;\n  height: 100%;\n  max-height: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  src: url(', ');\n  max-height: 45px;\n'], ['\n  src: url(', ');\n  max-height: 45px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

require('../globalstyle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var height = function height(props) {
  return props.height || '55px';
};

var Nav = _styledComponents2.default.nav(_templateObject, height, function (props) {
  return props.shadow && (0, _styledComponents.css)(_templateObject2);
});

var Title = _styledComponents2.default.div(_templateObject3);

var Items = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.inv && (0, _styledComponents.css)(_templateObject5);
});

var Links = _styledComponents2.default.div(_templateObject6);

var Logo = _styledComponents2.default.div(_templateObject7, height);

var Img = _styledComponents2.default.img(_templateObject8, function (props) {
  return props.src;
});

var Navbar = function Navbar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      to = _ref.to,
      logo = _ref.logo,
      height = _ref.height,
      shadow = _ref.shadow,
      inv = _ref.inv;
  return _react2.default.createElement(
    Nav,
    { className: className, style: style, height: height, shadow: shadow },
    _react2.default.createElement(
      Items,
      { inv: inv },
      _react2.default.createElement(
        Title,
        null,
        to ? _react2.default.createElement(
          'a',
          { href: to },
          title
        ) : _react2.default.createElement(
          'h1',
          null,
          title
        )
      ),
      logo && _react2.default.createElement(
        Logo,
        null,
        _react2.default.createElement(Img, { src: logo })
      ),
      _react2.default.createElement(
        Links,
        null,
        children
      )
    )
  );
};

exports.default = Navbar;